import { render, staticRenderFns } from "./taxOutside.vue?vue&type=template&id=3d821efa&scoped=true"
import script from "./taxOutside.vue?vue&type=script&lang=js"
export * from "./taxOutside.vue?vue&type=script&lang=js"
import style0 from "./taxOutside.vue?vue&type=style&index=0&id=3d821efa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d821efa",
  null
  
)

export default component.exports